import React from 'react';
import { useTranslation } from 'react-i18next';
import MainHeader from './header/MainHeader';
import Footer from './footer/Footer';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <>
      <MainHeader />
      <div
        className="d-flex flex-column justify-content-center align-items-center text-center"
        style={{
          padding: '150px 0',
          background: '#fff',
          color: '#000',
        }}
      >
        <h1
          style={{
            fontSize: '7rem',
            fontWeight: '700',
            color: 'var(--color1)',
          }}
        >
          404
        </h1>
        <h2 style={{ fontSize: '3rem', fontWeight: '500' }}>
          {t('notfound.subtitle')}
        </h2>
        <p style={{ color: 'var(--color1)' }}>
          {t('notfound.description')}
        </p>
        <a
          href="/"
          className="btn btn-lg mt-3"
          style={{
            backgroundColor: '#1e2a48',
            color: '#fff',
            borderRadius: 'var(--btn-radius)',
            padding: '10px 30px',
          }}
        >
          {t('notfound.go_home')}
        </a>
      </div>
      <Footer />
    </>
  );
}
